import type { ReactNode } from 'react';
import type { TFunction } from 'i18next';
import { Trans } from 'react-i18next';
import { I18nNamespace } from '@/lib/i18n-namespaces';
import { AppRoutes } from '@/constants/routes';
import { DatabaseEvent } from '@/types/event';

export function getDatabaseEventTitle(
    t: TFunction,
    databaseEvent: DatabaseEvent,
): ReactNode {
    if (databaseEvent.entityType !== 'vehicle') {
        return t('databaseEvent.person', { ns: I18nNamespace.EVENTS });
    }
    if (!databaseEvent.licensePlate) {
        return t('databaseEvent.vehicle', { ns: I18nNamespace.EVENTS });
    }
    return (
        <Trans
            t={t}
            ns={I18nNamespace.EVENTS}
            i18nKey="databaseEvent.vehicleWithPlate"
            values={{ licensePlate: databaseEvent.licensePlate }}
            components={{ plate: <span className="font-geist-mono" /> }}
        />
    );
}

export function getDatabaseEventName(
    t: TFunction,
    databaseEvent: DatabaseEvent,
): string {
    if (databaseEvent.entityName) return databaseEvent.entityName;
    return t('databaseEvent.unknown', { ns: I18nNamespace.EVENTS });
}

export function getDatabaseEventLicensePlate(
    databaseEvent: DatabaseEvent,
): string | undefined {
    if (databaseEvent.entityType !== 'vehicle' || databaseEvent.entityName)
        return undefined;
    return databaseEvent.licensePlate ?? undefined;
}

export function buildDatabaseEventWatchUrl(
    databaseEvent: DatabaseEvent,
): string {
    const entityUrl =
        databaseEvent.entityType === 'vehicle'
            ? AppRoutes.VEHICLE.replace(':vehicleId', databaseEvent.entityId)
            : AppRoutes.PERSON.replace(':personId', databaseEvent.entityId);
    return `${entityUrl}?watch=${databaseEvent.event.id}`;
}
